const configurationRoutes = (prop) => [
  {
    path: 'dashboard',
    name: prop + '.dashboard',
    meta: { auth: true, name: 'Editable' },
    component: () => import('../pages/Dashboard.vue')
  },
  {
    path: 'business-type',
    name: prop + '.business_type',
    meta: { auth: true, name: 'Editable' },
    component: () => import('../pages/business-type/List.vue')
  },
  {
    path: 'fair-calendar',
    name: prop + '.fair_calendar',
    meta: { auth: true, name: 'Editable' },
    component: () => import('../pages/fair-calendar/List.vue')
  },
  {
    path: 'stall-category',
    name: prop + '.stall_category',
    meta: { auth: true, name: 'Editable' },
    component: () => import('../pages/stall-category/List.vue')
  },
  {
    path: 'stall-information',
    name: prop + '.stall_information',
    meta: { auth: true, name: 'Editable' },
    component: () => import('../pages/stall-information/List.vue')
  },
  {
    path: 'stall-information-form',
    name: prop + '.stall_information_form',
    meta: { auth: true, name: 'Editable' },
    component: () => import('../pages/stall-information/Form.vue')
  },
  {
    path: 'security-money',
    name: prop + '.security_money',
    meta: { auth: true, name: 'Editable' },
    component: () => import('../pages/security-money/List.vue')
  },
  {
    path: 'bank-info',
    name: prop + '.bank_info',
    meta: { auth: true, name: 'Editable' },
    component: () => import('../pages/bank-info/List.vue')
  },
  {
    path: 'dollar-rate',
    name: prop + '.dollar_rate',
    meta: { auth: true, name: 'Editable' },
    component: () => import('../pages/dollar-rate/List.vue')
  },
  {
    path: 'user-assign',
    name: prop + '.user_assign',
    meta: { auth: true, name: 'Editable' },
    component: () => import('../pages/user-assign/Form.vue')
  },
  {
    path: 'user-assign-list',
    name: prop + '.user_assign',
    meta: { auth: true, name: 'Editable' },
    component: () => import('../pages/user-assign/List.vue')
  },
  {
    path: 'fair-fee',
    name: prop + '.fair_fee',
    meta: { auth: true, name: 'Editable' },
    component: () => import('../pages/fair-fee/List.vue')
  },
  {
    path: 'fair-condition',
    name: prop + '.fair_condition',
    meta: { auth: true, name: 'Editable' },
    component: () => import('../pages/fair-condition/List.vue')
  }
]

const routes = [
  {
    path: '/trade-fair-service/ditf/configuration',
    name: 'trade_fair_service.configuration',
    component: () => import('@/layouts/TradeFairServiceLayout.vue'),
    meta: { auth: true },
    children: configurationRoutes('trade_fair_service.configuration')
  }
]

export default routes
